import Image from 'next/image';
import React from 'react';
import Link from 'next/link';

import { CategoryBlogPost } from '../../../../pages/blog';
import { replaceTripshepherdWithSeeSight } from '../../../../utils/trip-sheppered-text';

interface CategoryBlogCardProps {
  blogCardDetails: CategoryBlogPost;
}

export default function CategoryBlogCard({
  blogCardDetails
}: CategoryBlogCardProps) {
  return (
    <Link
      className="h-[335px] px-2 pt-2 pb-[20px] bg-white rounded-2xl border border-[#e0e0e0] flex flex-col justify-start gap-[9px] cursor-pointer hover:shadow-md"
      href={`/blog/${blogCardDetails.slug}`}
    >
      <div className="h-[180px] !overflow-hidden rounded-lg">
        <Image
          src={blogCardDetails.image}
          alt={blogCardDetails.page_title}
          width={300}
          height={180}
          className="rounded-lg w-[100%] h-[100%] hover:scale-105 ease-in-out duration-200"
        />
      </div>

      <div className="h-[26px] px-2 py-[3px] bg-[#859ead] rounded-sm justify-center items-center gap-2.5 w-fit flex">
        <p className="text-white text-[10px] sm:text-[13px] font-semibold capitalize leading-tight">
          {blogCardDetails.category ?? 'Experiences'}
        </p>
      </div>
      <div
        id="title"
        className="h-[48px] overflow-hidden"
        style={{
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical'
        }}
      >
        <h2
          className={`text-[15px] sm:text-base leading-[22px] sm:leading-[24px] font-semibold line-clamp-2 text-ellipsis`}
        >
          {blogCardDetails?.page_title?.includes('-') &&
          replaceTripshepherdWithSeeSight(blogCardDetails?.page_title)
            ?.split('-')
            ?.pop()
            ?.trim() === 'See Sight Tours'
            ? blogCardDetails.page_title
                .split('-')
                .slice(0, -1)
                .join('-')
                .trim()
            : blogCardDetails.page_title}
        </h2>
      </div>
      <div className="flex gap-2 xsm:gap-5 xl:gap-4">
        <div className="flex gap-1.5 items-center">
          <Image
            src={`/calendar-icon.svg`}
            alt="calender-icon"
            width={24}
            height={24}
            className="w-4 h-4 md:w-5 md:h-5"
          />
          <p className="text-[11px] sm:text-[13px] leading-[13px] text-gray75 whitespace-nowrap">
            {blogCardDetails.publication_date}
          </p>
        </div>
        {blogCardDetails.author && (
          <div className="flex gap-1.5 items-center">
            <p className="text-[11px] sm:text-[13px] leading-[13px] text-gray75 whitespace-nowrap">
              {blogCardDetails.author}
            </p>
          </div>
        )}
      </div>
    </Link>
  );
}
